import React, { useState, useEffect } from 'react';
import companyConfig from '../config/companyConfig';

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = localStorage.getItem('cookieConsent');
    if (!hasAccepted) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setShowBanner(true);
      }, companyConfig.cookieConsent.showDelay);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-content">
          <div className="cookie-icon">
            <i className="fas fa-cookie-bite"></i>
          </div>
          <div className="cookie-text">
            <h3 className="cookie-title">{companyConfig.cookieConsent.title}</h3>
            <p className="cookie-description">
              {companyConfig.cookieConsent.message}
              <a href={companyConfig.cookieConsent.learnMoreLink} className="cookie-link">
                {' '}{companyConfig.cookieConsent.learnMoreText}
              </a>
            </p>
          </div>
        </div>
        <div className="cookie-actions">
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            {companyConfig.cookieConsent.declineButtonText}
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            {companyConfig.cookieConsent.acceptButtonText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
